import type { EntityDailyHistoryRow } from './EntityDailyHistoryPanel.types';

export const collectExpandableRowIds = (
  rows: readonly EntityDailyHistoryRow[],
): readonly string[] =>
  rows.flatMap((row) => {
    const hasChildren = row.hasExpandableChildren ?? Boolean(row.childRows?.length);
    const childRowIds = row.childRows ? collectExpandableRowIds(row.childRows) : [];
    return hasChildren ? [row.id, ...childRowIds] : childRowIds;
  });
